import { SalesDataProvider } from "contexts/SalesDataContext";
import { SalesDataTabContent } from "./SalesDataTabContent";

interface SalesDataTabProps {
  isExplainerOpen: boolean;
  onDismissExplainer: () => void;
}

/**
 * Wraps the tab body in `SalesDataProvider` so the date-range picker and the
 * Total Sales query share one window (`from`/`to`) via `SalesDataContext`.
 */
export const SalesDataTab = (props: SalesDataTabProps) => (
  <SalesDataProvider>
    <SalesDataTabContent {...props} />
  </SalesDataProvider>
);
